<template>
  
  <a-yoga-layout
      width-auto="1" height-auto="1"
      padding="0.075"
      flex-wrap="wrap"
      flex-direction="column"
      align-items="center"
      justify-content="center"

      class="clickable"

      geometry="primitive: rounded-plane;" material="color: #001034;"
      push-mesh-backwards="distance: 0.02"
  >

    <a-image
        src="/aframe-assets/icons/cancel-padded.png"
        width="0.07" height="0.07"
        yoga-layout-item="position: absolute; right:0.07; top:0.07"
        class="clickable"
        ui-icon
        toggle-modal="#navigationPanel"
    />

    <a-yoga-layout
        :width="panelWidth" height-auto="1"
        flex-wrap="wrap"
        flex-direction="row"
        align-items="flex-start"
        justify-content="flex-start"
        padding="0"
        geometry="primitive: plane;" material="visible: false"
    >
      <a-entity
          html-dev
          geometry="primitive: plane; width:0; height: 0" material="visible: false; transparent: true"
          yoga-layout-item="margin: 0.04; marginEdge: left; padding: 0"
      >
        <div class="vr" >
          <h1>{{ $t("rooms_to_explore") }}</h1>
        </div>
      </a-entity>
    </a-yoga-layout>

    <a-yoga-layout
        :width="panelWidth" height-auto="1"
        flex-wrap="wrap"
        flex-direction="row"
        align-items="flex-start"
        justify-content="flex-start"
        padding="0"
        geometry="primitive: plane;" material="visible: false"
    >

      <a-yoga-layout
          v-for="_page in pages"
          v-bind:key="_page.id"
          :id="'image-'+_page.title"
          width="0.35" height="0.35"
          flex-wrap="nowrap"
          flex-direction="column"
          align-items="flex-start"
          justify-content="flex-start"
          geometry="primitive: plane;" material="visible: false;"
          class="clickable"

          margin="0" padding="0.05"
          yoga-layout-item="margin: 0.03; padding: 0.03"

          hover-effect-scale="scale: 1.15"
          @click="selectPage(_page)"
      >

        <a-image
            :src="_page.sky_thumbnail"
            width="0.35" height="0.26"

            yoga-layout-item="margin: 0; marginEdge: all"

        ></a-image>

        <a-entity
            html-dev="autoEnable: false"
            geometry="primitive: plane; width:0.35; height: 0.1" material="visible: false; transparent: true"
            yoga-layout-item="margin: 0; marginEdge: all; padding: 0"
        >
          <div
              class="vr uxk-text-center"
          >
                    <span class="link" v-if="currentPage && _page.id !== currentPage.id">
                        {{ _page.title }}
                    </span>
            <strong class="link" v-if="currentPage && _page.id === currentPage.id">
              &raquo; {{ _page.title }}
            </strong>
          </div>
        </a-entity>
      </a-yoga-layout>
    </a-yoga-layout>
    
  </a-yoga-layout>
</template>

<script>
export default {
    name: "NavigationPanel",
    props: ['pages','currentPage'],
    computed: {
        panelWidth: function() {
            let amountHorizontal = 2;
            const pageCount = this.pages.length;
            if (pageCount >= 5) amountHorizontal = 3;
            if (pageCount >= 13) amountHorizontal = 4;
            if (pageCount >= 17) amountHorizontal = 5;
            return (amountHorizontal * (0.35+0.03+0.03)) + (2*0.1);
        }
    },
    methods: {
        selectPage(page) {
            this.$emit('select-page', page);
            document.querySelector('#navigationPanel').setAttribute('advanced-visible',false);
        },
    }
}
</script>

<style scoped>

</style>